import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {WinterHoardLayerConfig} from "../config/WinterHoardLayerConfig";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {Timeline, TimelineMax, TweenLite,TimelineLite, TweenMax, Circ} from "gsap";
import {WinterHoardReelSymbol} from "../symbols/WinterHoardReelSymbol";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {SoundPlayer} from "../sound/SoundPlayer";
import {WinterHoardSoundConfig} from "../WinterHoardSoundConfig";


export class FreespinEnergyCollector extends BaseView {

    private _blastGrid: {
            landscape: TimelineSprite,
            portrait: TimelineSprite
        } [][];
    private _layer:ScalableLayer;

    private _landscapeContainer:PIXI.Container =  new PIXI.Container();
    private _portraitContainer:PIXI.Container =  new PIXI.Container();

    private _isFourTreeP:boolean = false;

    private _lEndPos: {
        M2: number [][][],
        M3: number [][][],
        M4: number [][][],
        M5: number [][][],
    } = {   // TODO: Only first index is necessesary
        M5: [
            [[-80, 570]],   [[-20, 450]], [[-20, 450]], [[-20, 450]], [[-20, 450]]
        ],
        M4: [
            [[-80, 480]],   [[500, 0]], [[500, 0]], [[500, 0]], [[500, 0]]
        ],
        M3: [
            [[-80, 390]],   [[500, 0]], [[500, 0]], [[500, 0]], [[500, 0]]
        ],
        M2: [
            [[-80, 300]],   [[500, 0]], [[500, 0]], [[500, 0]], [[500, 0]]
        ]
    };

    private _pEndPos: {
        M2: number [][][],
        M3: number [][][],
        M4: number [][][],
        M5: number [][][],
    } = { // TODO: Only first index is necessesary
        M5: [
            [[545, -10]],         [[500, 0]], [[500, 0]], [[500, 0]], [[500, 0]]
        ],
        M4: [
            [[475, -90]],         [[500, 0]], [[500, 0]], [[500, 0]], [[500, 0]]
        ],
        M3: [
            [[150, -10]],         [[500, 0]], [[500, 0]], [[500, 0]], [[500, 0]]
        ],
        M2: [
            [[200, -90]],         [[500, 0]], [[500, 0]], [[500, 0]], [[500, 0]]
        ]
    };

    private _pEndPosFourTree : {
        M2: number [][][],
        M3: number [][][],
        M4: number [][][],
        M5: number [][][],
    } = { // TODO: Only first index is necessesary
        M5: [
            [[470, 10]],         [[500, 0]], [[500, 0]], [[500, 0]], [[500, 0]]
        ],
        M4: [
            [[430, -30]],         [[500, 0]], [[500, 0]], [[500, 0]], [[500, 0]]
        ],
        M3: [
            [[220, 10]],         [[500, 0]], [[500, 0]], [[500, 0]], [[500, 0]]
        ],
        M2: [
            [[255, -30]],         [[500, 0]], [[500, 0]], [[500, 0]], [[500, 0]]
        ]
    };

    private _currentEndPos : {
        M2: number [][][],
        M3: number [][][],
        M4: number [][][],
        M5: number [][][],
    };

    private _landscapeEndEffects: PIXI.Sprite [][] = [];
    private _portraitEndEffects: PIXI.Sprite [][] = [];
    private _landscapeEndEffectPos: PIXI.Point [] = [
        new PIXI.Point(-135, 180),
        new PIXI.Point(-110, 310),
        new PIXI.Point(-105, 400),
        new PIXI.Point(-105, 500),
        new PIXI.Point(-100, 600)
    ];

    private _portraitEndEffectPos: PIXI.Point [] = [
        new PIXI.Point(360, -60),
        new PIXI.Point(223, -100),
        new PIXI.Point(150, -16),
        new PIXI.Point(502, -100),
        new PIXI.Point(575, -14),
    ];

    private _portraitEndEffectPosFourTree: PIXI.Point [] = [
        new PIXI.Point(355, -30),
        new PIXI.Point(265, -50),
        new PIXI.Point(225, 0),
        new PIXI.Point(440, -50),
        new PIXI.Point(480, 0),
    ];



    private testTls: Timeline [] = [];


    constructor() {
        super();

        this._layer = StageManager.getLayer(WinterHoardLayerConfig.BLAST_LANDSCAPE.name);
        this._layer.addChild(this);
    }

    testEnergy(): void {

        this.testTls.forEach((tl) => {
            tl.pause();
            tl.kill();
        });
        this.testTls.length = 0;

        this.testTls.push(this.playEnergyTransmission("M2",4, 0));
        this.testTls.push(this.playEnergyTransmission("M2", 3, 1));
        this.testTls.push(this.playEnergyTransmission("M2", 2, 2));
        this.testTls.push(this.playEnergyTransmission("M2", 1, 3));
        this.testTls.push(this.playEnergyTransmission("M2", 0, 3));
    }

    initAnimations() {
        this.addChild(this._landscapeContainer);
        this.addChild(this._portraitContainer);

        this._blastGrid = this.createStartPointGrid();

        this._blastGrid.forEach((arr, rid) => {
            arr.forEach((obj, sid) => {
                const position = Helper.getSymbolPositions(rid, sid);

                //const sprite:PIXI.s =
                obj.landscape.blendMode = PIXI.BLEND_MODES.ADD;
                obj.portrait.blendMode = PIXI.BLEND_MODES.ADD;
                this._landscapeContainer.addChild(obj.landscape);
                this._portraitContainer.addChild(obj.portrait);

                obj.landscape.visible = false;
                obj.portrait.visible = false;

                //obj.portrait.anchor.set(.5, .5); // The correct way
                obj.landscape.anchor.set(0.05, 0.35);

                //obj.portrait.pivot.set(obj.portrait.getGlobalPosition().x, obj.portrait.getGlobalPosition().y + obj.portrait.height/2);


                obj.portrait.setFrame(1);
                //obj.landscape.setFrame(1);

                obj.landscape.scale.set(0.3, 1);
                obj.portrait.scale.set(0.3, 1);

                if(sid === 0) {
                    obj.portrait.pivot.set(500, 40);
                    /*obj.portrait.position.set(position[0] + 100, position[1] + 30);
                    const spr:PIXI.Sprite = new PIXI.Sprite(PIXI.Texture.WHITE);
                    spr.width = 30;
                    spr.height = 30;
                    spr.position = obj.portrait.pivot;
                    console.log("PIVOT :::::::::::");
                    console.log(obj.portrait.pivot);
                    obj.portrait.addChild(spr);*/
                }
                else {
                    obj.portrait.position.set(position[0] + 100, position[1]);
                }


            });
        });

        this.createMeterEndEffect();

    }

    protected createMeterEndEffect():void {

        const lArr:PIXI.Sprite [][] = [
            [
                new PIXI.Sprite(GameResources.getTextures("ringGlowEffect")[0]),
                new PIXI.Sprite(GameResources.getTextures("ringGlowEffect")[0]),
                new PIXI.Sprite(GameResources.getTextures("ringGlowEffect")[0]),
                new PIXI.Sprite(GameResources.getTextures("ringGlowEffect")[0]),
                new PIXI.Sprite(GameResources.getTextures("ringGlowEffect")[0])
            ],
            [
                new PIXI.Sprite(),
                new PIXI.Sprite(GameResources.getTextures("ringGlowEffect")[0]),
                new PIXI.Sprite(GameResources.getTextures("ringGlowEffect")[0]),
                new PIXI.Sprite(GameResources.getTextures("ringGlowEffect")[0]),
                new PIXI.Sprite(GameResources.getTextures("ringGlowEffect")[0])
            ],
            [
                new PIXI.Sprite(),
                new PIXI.Sprite(GameResources.getTextures("ringGlowEffect")[0]),
                new PIXI.Sprite(GameResources.getTextures("ringGlowEffect")[0]),
                new PIXI.Sprite(GameResources.getTextures("ringGlowEffect")[0]),
                new PIXI.Sprite(GameResources.getTextures("ringGlowEffect")[0])
            ],
            [
                new PIXI.Sprite(),
                new PIXI.Sprite(GameResources.getTextures("ringGlowEffect")[0]),
                new PIXI.Sprite(GameResources.getTextures("ringGlowEffect")[0]),
                new PIXI.Sprite(GameResources.getTextures("ringGlowEffect")[0]),
                new PIXI.Sprite(GameResources.getTextures("ringGlowEffect")[0])
            ],
            [
                new PIXI.Sprite(),
                new PIXI.Sprite(GameResources.getTextures("ringGlowEffect")[0]),
                new PIXI.Sprite(GameResources.getTextures("ringGlowEffect")[0]),
                new PIXI.Sprite(GameResources.getTextures("ringGlowEffect")[0]),
                new PIXI.Sprite(GameResources.getTextures("ringGlowEffect")[0])
            ]
        ];
        const pArr:PIXI.Sprite [][] = [
            [
                new PIXI.Sprite(GameResources.getTextures("ringGlowEffect")[0]),
                new PIXI.Sprite(GameResources.getTextures("ringGlowEffect")[0]),
                new PIXI.Sprite(GameResources.getTextures("ringGlowEffect")[0]),
                new PIXI.Sprite(GameResources.getTextures("ringGlowEffect")[0]),
                new PIXI.Sprite(GameResources.getTextures("ringGlowEffect")[0])
            ],
            [
                new PIXI.Sprite(),
                new PIXI.Sprite(GameResources.getTextures("ringGlowEffect")[0]),
                new PIXI.Sprite(GameResources.getTextures("ringGlowEffect")[0]),
                new PIXI.Sprite(GameResources.getTextures("ringGlowEffect")[0]),
                new PIXI.Sprite(GameResources.getTextures("ringGlowEffect")[0])
            ],
            [
                new PIXI.Sprite(),
                new PIXI.Sprite(GameResources.getTextures("ringGlowEffect")[0]),
                new PIXI.Sprite(GameResources.getTextures("ringGlowEffect")[0]),
                new PIXI.Sprite(GameResources.getTextures("ringGlowEffect")[0]),
                new PIXI.Sprite(GameResources.getTextures("ringGlowEffect")[0])
            ],
            [
                new PIXI.Sprite(),
                new PIXI.Sprite(GameResources.getTextures("ringGlowEffect")[0]),
                new PIXI.Sprite(GameResources.getTextures("ringGlowEffect")[0]),
                new PIXI.Sprite(GameResources.getTextures("ringGlowEffect")[0]),
                new PIXI.Sprite(GameResources.getTextures("ringGlowEffect")[0])
            ],
            [
                new PIXI.Sprite(),
                new PIXI.Sprite(GameResources.getTextures("ringGlowEffect")[0]),
                new PIXI.Sprite(GameResources.getTextures("ringGlowEffect")[0]),
                new PIXI.Sprite(GameResources.getTextures("ringGlowEffect")[0]),
                new PIXI.Sprite(GameResources.getTextures("ringGlowEffect")[0])
            ]

        ];

        lArr.forEach((spriteArr, indexOuter) => {

            spriteArr.forEach((sprite, indexInner) => {
                sprite.anchor.set(0.5, 0.5);

                if(indexInner === 0 && indexOuter === 0) {
                    sprite.scale.set(0.82, 0.82);
                    this._landscapeContainer.addChild(sprite);
                }
                else if(indexInner > 0 && indexOuter > 0) {
                    sprite.scale.set(0.45, 0.45);
                    this._landscapeContainer.addChild(sprite);
                }
                sprite.position = this._landscapeEndEffectPos[indexOuter];
                sprite.blendMode = PIXI.BLEND_MODES.ADD;
                sprite.visible = false;
            });


        });

        pArr.forEach((spriteArr, indexOuter) => {

            spriteArr.forEach((sprite, indexInner) => {
                sprite.anchor.set(0.5, 0.5);

                if(indexInner === 0 && indexOuter === 0) {
                    sprite.scale.set(0.82, 0.82);
                    this._portraitContainer.addChild(sprite);
                }
                else if(indexInner > 0 && indexOuter > 0) {
                    sprite.scale.set(0.5, 0.5);
                    //if(indexInner < 2)
                    this._portraitContainer.addChild(sprite);
                }
                sprite.position = this._portraitEndEffectPos[indexOuter];
                sprite.blendMode = PIXI.BLEND_MODES.ADD;
                sprite.visible = false;
            });

        });


        this._landscapeEndEffects = lArr;
        this._portraitEndEffects = pArr;
    }

    public playEnergyEnd(meterIndex: number, energyIndex: number, delay:number = 0.15): Timeline {
        const tl:TimelineLite = new TimelineLite();

        tl.add([
            () => {
                this._landscapeEndEffects[meterIndex][energyIndex].visible = true;
                this._portraitEndEffects[meterIndex][energyIndex].visible = true;
            },
            TweenMax.fromTo(this._landscapeEndEffects[meterIndex][energyIndex], delay, {
                alpha: 0,
                yoyo: true,
                ease: Circ.easeInOut
            }, {
                alpha: 1
            }),
            TweenMax.fromTo(this._portraitEndEffects[meterIndex][energyIndex], delay, {
                alpha: 0,
                yoyo: true,
                ease: Circ.easeInOut
            }, {
                alpha: 1
            })
        ], delay);
        tl.add(() => {
            this._landscapeEndEffects[meterIndex][energyIndex].visible = false;
            this._portraitEndEffects[meterIndex][energyIndex].visible = false;
        });

        return tl;
    }

    protected rotateToPoint(targetX:number, targetY:number, startX:number, startY:number){
        const dist_Y = targetY - startY;
        const dist_X = targetX - startX;
        const angle = Math.atan2(dist_Y,dist_X);
        //var degrees = angle * 180/ Math.PI;
        return angle;
    }

    public degreesToRad(degrees:number)
    {
        return degrees * (Math.PI/180);
    }

    createStartPointGrid():{ landscape: TimelineSprite, portrait: TimelineSprite } [][] {
        // TODO: The energy animation will originate from corresponding symbol position.
        return [
            [
                {
                    landscape: new TimelineSprite(GameResources.getTextures("energyBlast")),
                    portrait: new TimelineSprite(GameResources.getTextures("energyBlast"))
                },
                {
                    landscape: new TimelineSprite(GameResources.getTextures("energyBlast")),
                    portrait: new TimelineSprite(GameResources.getTextures("energyBlast"))
                },
                {
                    landscape: new TimelineSprite(GameResources.getTextures("energyBlast")),
                    portrait: new TimelineSprite(GameResources.getTextures("energyBlast"))
                },
                {
                    landscape: new TimelineSprite(GameResources.getTextures("energyBlast")),
                    portrait: new TimelineSprite(GameResources.getTextures("energyBlast"))
                }
            ],
            [
                {
                    landscape: new TimelineSprite(GameResources.getTextures("energyBlast")),
                    portrait: new TimelineSprite(GameResources.getTextures("energyBlast"))
                },
                {
                    landscape: new TimelineSprite(GameResources.getTextures("energyBlast")),
                    portrait: new TimelineSprite(GameResources.getTextures("energyBlast"))
                },
                {
                    landscape: new TimelineSprite(GameResources.getTextures("energyBlast")),
                    portrait: new TimelineSprite(GameResources.getTextures("energyBlast"))
                },
                {
                    landscape: new TimelineSprite(GameResources.getTextures("energyBlast")),
                    portrait: new TimelineSprite(GameResources.getTextures("energyBlast"))
                }
            ],
            [
                {
                    landscape: new TimelineSprite(GameResources.getTextures("energyBlast")),
                    portrait: new TimelineSprite(GameResources.getTextures("energyBlast"))
                },
                {
                    landscape: new TimelineSprite(GameResources.getTextures("energyBlast")),
                    portrait: new TimelineSprite(GameResources.getTextures("energyBlast"))
                },
                {
                    landscape: new TimelineSprite(GameResources.getTextures("energyBlast")),
                    portrait: new TimelineSprite(GameResources.getTextures("energyBlast"))
                },
                {
                    landscape: new TimelineSprite(GameResources.getTextures("energyBlast")),
                    portrait: new TimelineSprite(GameResources.getTextures("energyBlast"))
                }
            ],
            [
                {
                    landscape: new TimelineSprite(GameResources.getTextures("energyBlast").slice(1, 5), 12),
                    portrait: new TimelineSprite(GameResources.getTextures("energyBlast"))
                },
                {
                    landscape: new TimelineSprite(GameResources.getTextures("energyBlast").slice(1, 5), 12),
                    portrait: new TimelineSprite(GameResources.getTextures("energyBlast").slice(7))
                },
                {
                    landscape: new TimelineSprite(GameResources.getTextures("energyBlast").slice(1, 5), 12),
                    portrait: new TimelineSprite(GameResources.getTextures("energyBlast").slice(7))
                },
                {
                    landscape: new TimelineSprite(GameResources.getTextures("energyBlast").slice(1, 5), 12),
                    portrait: new TimelineSprite(GameResources.getTextures("energyBlast").slice(7))
                }
            ],
            [
                {
                    landscape: new TimelineSprite(GameResources.getTextures("energyBlast").slice(1, 5), 12),
                    portrait: new TimelineSprite(GameResources.getTextures("energyBlast").slice(7))
                },
                {
                    landscape: new TimelineSprite(GameResources.getTextures("energyBlast").slice(1, 5), 12),
                    portrait: new TimelineSprite(GameResources.getTextures("energyBlast").slice(7))
                },
                {
                    landscape: new TimelineSprite(GameResources.getTextures("energyBlast").slice(1, 5), 12),
                    portrait: new TimelineSprite(GameResources.getTextures("energyBlast").slice(7))
                },
                {
                    landscape: new TimelineSprite(GameResources.getTextures("energyBlast").slice(1, 5), 12),
                    portrait: new TimelineSprite(GameResources.getTextures("energyBlast").slice(7))
                }
            ]
        ];
    }

    protected blastGridResize(orientation:Orientation):void {

        if(orientation === Orientation.LANDSCAPE) {
            this._landscapeContainer.visible = true;
            this._portraitContainer.visible = false;
        }
        else{
            this._landscapeContainer.visible = false;
            this._portraitContainer.visible = true;
        }

        this._blastGrid.forEach((arr, rid) => {
            arr.forEach((obj, sid) => {
                const position = Helper.getSymbolPositions(rid, sid);
                //TODO:  this x- calc is essential everywhere because of reel resize, see if you can fix core problem
                obj.landscape.position.set(position[0] - (rid * 10), position[1]);

                if(sid === 0) {
                    obj.portrait.position.set(position[0] + 100, position[1] + 30);
                }
                else {
                    obj.portrait.position.set(position[0] + 100, position[1]);
                }

                //obj.landscape.playLoop();
            });
        });
    }

    public playEnergyTransmission(meterSym:string, rid:number = 0, sid:number = 0, cntr:number = 0):Timeline {
        const tl:Timeline = new TimelineMax(/*{repeat: -1}*/);
        let meterIndex:number = 0;

        if(meterSym === "") {
            return new TimelineLite();
        }

        const tSpriteLandscape:TimelineSprite = this._blastGrid[rid][sid].landscape;
        const tSpritePortrait:TimelineSprite = this._blastGrid[rid][sid].portrait;



        const lEndPos: {
            M2: number [][][],
            M3: number [][][],
            M4: number [][][],
            M5: number [][][],
        } = this._lEndPos;


        let pEndPos: {
            M2: number [][][],
            M3: number [][][],
            M4: number [][][],
            M5: number [][][],
        } = this._pEndPos;
        if(this._isFourTreeP) {
            pEndPos = this._pEndPosFourTree;
        }

        let pPositions: number [][][] = [];
        switch(meterSym) {
            case "M5":
                pPositions = pEndPos.M5;
                meterIndex = 4;
                break;
            case "M4":
                pPositions = pEndPos.M4;
                meterIndex = 3;
                break;
            case "M3":
                pPositions = pEndPos.M3;
                meterIndex = 2;
                break;
            case "M2":
                pPositions = pEndPos.M2;
                meterIndex = 1;
                break;
        }

        let lPositions: number [][][] = [];
        switch(meterSym) {
            case "M5":
                lPositions = lEndPos.M5;
                break;
            case "M4":
                lPositions = lEndPos.M4;
                break;
            case "M3":
                lPositions = lEndPos.M3;
                break;
            case "M2":
                lPositions = lEndPos.M2;
                break;
        }

        const pivotOnPlaceAndRotate:PIXI.Point = new PIXI.Point(0, 40);
        const pivotOnTween:PIXI.Point = new PIXI.Point(500, 40);

        const tmp:boolean = true;

        // setup landscape
        if(pPositions && lPositions) {
            tl.add([
                () => {
                    const symbol:WinterHoardReelSymbol | null = <WinterHoardReelSymbol> Reels.getSymbol(rid, sid);
                    if(symbol) {
                        symbol.playNormalSpine();
                    }
                },
                //TweenLite.to(tSpriteLandscape, (rid * 0.2) + 0.5,
                // {
                 //       x: /*-(3 * -25) +*/ positions[rid][sid][0], // - this._landscapeXoffset,
                   //     y: /*(sid === 3)? -(6 * -35) + positions[1] : -(sid * -45) +*/ positions[rid][sid][1]
                    //}),
                //() => tSpriteLandscape.playLoop(),

                // TODO: Remade Landscape
                () => {
                        if(tmp) {
                            const position = Helper.getSymbolPositions(rid, sid);
                            tSpriteLandscape.pivot = pivotOnPlaceAndRotate;

                            //if(sid === 0) {
                                //tSpritePortrait.position.set(position[0], position[1] + 30);
                            //}
                            //else {
                            tSpriteLandscape.position.set(position[0], position[1]);
                            //}

                            if(lPositions) {
                                tSpriteLandscape.show();

                                tSpriteLandscape.rotation = /*(this.degreesToRad(15) * sid) + */this.rotateToPoint(lPositions[0][0][0], lPositions[0][0][1], tSpriteLandscape.x, tSpriteLandscape.y);
                            }

                        }
                },

                TweenLite.to(tSpriteLandscape, (cntr * 0.1) + 0.3,
                    {
                        x: lPositions[0][0][0],
                        y: lPositions[0][0][1]
                    }),

                TweenLite.to(tSpriteLandscape.pivot, (cntr * 0.1) + 0.3,
                    {
                        x: pivotOnTween.x,
                        y: pivotOnTween.y
                    }),
                () => tSpriteLandscape.playLoop(),

                // PORTRAIT
                () => {

                    const position = Helper.getSymbolPositions(rid, sid);
                    tSpritePortrait.pivot = pivotOnPlaceAndRotate;

                    //TODO:  this x- calc is essential everywhere because of reel resize, see if you can fix core problem
                    if(sid === 0) {
                        tSpritePortrait.position.set(position[0], position[1] + 30);
                    }
                    else {
                        tSpritePortrait.position.set(position[0], position[1]);
                    }

                    if(pPositions) {
                        //tSpritePortrait.position.set(position[0], position[1]);
                        /*const spr:PIXI.Sprite = new PIXI.Sprite(PIXI.Texture.WHITE);
                        spr.width = 30;
                        spr.height = 30;
                        spr.position = tSpritePortrait.pivot;
                        console.log("PIVOT :::::::::::");
                        console.log(tSpritePortrait.pivot);
                        tSpritePortrait.addChild(spr);*/
                        //tSpriteLandscape.x = 30;
                        tSpritePortrait.show();
                        tSpritePortrait.rotation = /*(this.degreesToRad(15) * sid) + */this.rotateToPoint(pPositions[0][0][0], pPositions[0][0][1], tSpritePortrait.x, tSpritePortrait.y);
                    }

                },
                ()=>{SoundPlayer.playEffect(WinterHoardSoundConfig.PURPLE_DOT_FLY_TO_METER);},
                TweenLite.to(tSpritePortrait, (cntr * 0.1) + 0.3,
                    {
                        x: pPositions[0][0][0],
                        y: pPositions[0][0][1]
                    }),

                TweenLite.to(tSpritePortrait.pivot, (cntr * 0.1) + 0.3,
                    {
                        x: pivotOnTween.x,
                        y: pivotOnTween.y
                    }),
                () => tSpritePortrait.playLoop(),
                this.playEnergyEnd(meterIndex, cntr, 0.15),
                //(meterIndex === 1 && cntr === 4) ? this.playEnergyEnd(0, 0, 0.15) : () => {}

            ]);
            tl.add([
                () => {
                    tSpriteLandscape.stopLoop();
                    tSpriteLandscape.hide();
                    tSpritePortrait.stopLoop();
                    tSpritePortrait.hide();

                    const position = Helper.getSymbolPositions(rid, sid);
                    //TODO:  this x- calc is essential everywhere because of reel resize, see if you can fix core problem
                    tSpriteLandscape.pivot = pivotOnPlaceAndRotate;
                    tSpriteLandscape.position.set(position[0] - (rid * 10), position[1]);
                    //obj.portrait.position.set(position[0] - (rid * 10), position[1]);
                    //tSpriteLandscape.y = 0;
                    //tSpriteLandscape.x = 0;
                    //this.blastGridResize(Orientation.LANDSCAPE);
                    //this.blastGridResize(Orientation.PORTRAIT);

                    //TODO:  this x- calc is essential everywhere because of reel resize, see if you can fix core problem
                    if(sid === 0) {
                        tSpritePortrait.pivot = pivotOnPlaceAndRotate;
                        tSpritePortrait.position.set(position[0] + 100, position[1] + 30);
                    }
                    else {
                        tSpritePortrait.pivot = pivotOnPlaceAndRotate;
                        tSpritePortrait.position.set(position[0] + 100, position[1]);
                    }
                }
            ]);
        }

        return tl;
    }

    onResize(data:IResizeData) {

        if(data.orientation === Orientation.LANDSCAPE) {
            this.scale.set(0.9, 0.9);
            this.x = 50; // + this._landscapeXoffset; //
            this.blastGridResize(data.orientation);
        }
        else {
            if(data.height > 970) {
                this._isFourTreeP = false;
                this.scale.set(1, 1);
                this.x = 0;
                //this.y = -50;
                this.blastGridResize(data.orientation);

                this._portraitEndEffects.forEach((spriteArr, indexOuter) => {

                    spriteArr.forEach((sprite, indexInner) => {

                        if(indexInner === 0 && indexOuter === 0) {
                            sprite.scale.set(0.82, 0.82);
                            this._portraitContainer.addChild(sprite);
                        }
                        else if(indexInner > 0 && indexOuter > 0) {
                            sprite.scale.set(0.5, 0.5);
                        }
                        sprite.position = this._portraitEndEffectPos[indexOuter];

                    });

                });
            }
            else {
                this._isFourTreeP = true;
                this.scale.set(1, 1);
                this.x = 0;
                //this.y = -50;
                this.blastGridResize(data.orientation);

                this._portraitEndEffects.forEach((spriteArr, indexOuter) => {

                    spriteArr.forEach((sprite, indexInner) => {

                        if(indexInner === 0 && indexOuter === 0) {
                            sprite.scale.set(0.58, 0.58);
                            this._portraitContainer.addChild(sprite);
                        }
                        else if(indexInner > 0 && indexOuter > 0) {
                            sprite.scale.set(0.28, 0.28);
                        }
                        sprite.position = this._portraitEndEffectPosFourTree[indexOuter];

                    });

                });
            }
        }

        //this.testEnergy();
    }

}